import axios from 'axios';
import { API_BASE_URL } from '@/config';

const authClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export function authenticateSuperAdmin(credentials) {
  return authClient.post('auth/authenticate-super-admin', credentials);
}

export function authenticateLocationByName(credentials) {
  return authClient.post('auth/authenticate-by-name-password', credentials);
}

